export const dateTimeHandler = (isoTimestamp: string): string => {
  if (isoTimestamp) {
    const date = new Date(isoTimestamp);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const day = String(date.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  }
  return "";
};

export const Title = [
  { id: 1, name: "Mr" },
  { id: 2, name: "Mrs" },
  { id: 3, name: "Ms" },
  { id: 4, name: "Miss" },
  { id: 5, name: "Dr" },
];

export const Gender = [
  { id: 1, name: "Male" },
  { id: 2, name: "Female" },
  { id: 3, name: "Others" },
];

export default Gender;

export const MaritialStatus = [
  { id: 1, name: "Single" },
  { id: 2, name: "Married" },
  { id: 3, name: "Divorced" },
  { id: 4, name: "Widowed" },
  { id: 5, name: "Separated" },
  { id: 6, name: "Domestic Partnership" },
  { id: 7, name: "Civil Union" },
];

export type ReportStatusId = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10;


export const REPORT_STATUS: Record<ReportStatusId, string> = {
  1: "Draft",
  2: "Open",
  3: "Reported",
  4: "Work Assigned",
  5: "Work In Progress",
  6: "Work Completed",
  7: "In Review",
  8: "Cancelled",
  9: "Completed",
  10:"Closed",
};

export type AssessmentStatusId = 1 | 2 | 3 | 4 | 5 | 6;

export const RISK_ASSESSMENT_STATUS: Record<AssessmentStatusId, string> = {
  1: "Draft",
  2: "Submitted",
  3: "Linked",
  4: "Cancelled",
  5: "Resubmission",
  6: "Closed",
};

export const SAFETY_REPORT_STATUS = [
  { id: 1, status_name: "Draft" },
  // { id: 2, status_name: "In Progress" },
  { id: 3, status_name: "Submitted" },
  // { id: 4, status_name: "In Review" },
  { id: 5, status_name: "Cancelled" },
  { id: 6, status_name: "Closed" },
  { id: 7, status_name: "Resubmission" },
  { id: 8, status_name: "Revoked" },
  // { id: 9, status_name: "Expired" },
  { id: 10, status_name: "Approved" },
];

export const APPROVAL_STATUS = [
  // { id: 1, status_name: "Draft" },
  // { id: 2, status_name: "In Progress" },
  { id: 3, status_name: "Submitted" },
  // { id: 4, status_name: "In Review" },
  { id: 5, status_name: "Cancelled" },
  { id: 6, status_name: "Closed" },
  { id: 7, status_name: "Resubmission" },
  { id: 8, status_name: "Revoked" },
  // { id: 9, status_name: "Expired" },
  { id: 10, status_name: "Approved" },
];

export const INCIDENT_REPORT_STATUS = [
  { id: 1, status_name: "Draft" },
  { id: 2, status_name: "Reported" },
];

export const TOOLBOX_REPORT_STATUS = [
  { id: 1, status_name: "Draft" },
  // { id: 2, status_name: "Created" },
  { id: 3, status_name: "Submitted" },
  { id: 4, status_name: "Linked" },
  { id: 5, status_name: "Cancelled" },
  { id: 6, status_name: "Closed" },
  // { id: 7, status_name: "Resubmission" },
  // { id: 8, status_name: "Expired" },
  // { id: 9, status_name: "Approved" },
  // { id: 10, status_name: "Ended" },
];

export const PROJECT_STATUS = [
  { id: 1, status_name: "Active" },
  { id: 2, status_name: "Inactive" },
];

export const INSPECTION_STATUS = [
  { id: 1, status_name: "Draft" },
  { id: 2, status_name: "Open" },
  { id: 3, status_name: "Work Assigned" },
  { id: 4, status_name: "Work In Progress" },
  { id: 5, status_name: "Work Completed" },
  { id: 6, status_name: "In Review" },
  { id: 7, status_name: "Cancelled" },
  { id: 8, status_name: "Completed" },
  { id: 9, status_name: "Closed" },
];

export const INSPECTION_TYPE = [
  { id: 1, type_name: "Others" },
  { id: 2, type_name: "Weekly WSH Inspection Report" },
  { id: 3, type_name: "External Audit" },
  { id: 4, type_name: "Internal Audit" },
  { id: 5, type_name: "Monthly Commitee Inspection" },
  { id: 6, type_name: "Weekly Coordination Inspection" },
];

export const getStatusClass = (status: any) => {
  switch (status) {
    case "Draft":
      return "bg-secondary text-white";
    case "Open":
      return "bg-primary text-white";
    case "Work Assigned":
      return "bg-info text-white";
    case "Work In Progress":
      return "bg-warning text-dark";
    case "Work Completed":
      return "bg-success text-white";
    case "In Review":
      return "bg-primary text-white";
    case "Cancelled":
      return "bg-danger text-white";
    case "Completed":
      return "bg-success text-white";
    case "Closed":
      return "bg-dark text-white";
    default:
      return "bg-light text-dark";
  }
};
